import { atom } from 'jotai';

/**
 * Lifecycle phases visible in the corner badge while a splat layer is
 * being brought online by Spark. Bytes flowing → `fetching`; transfer
 * complete but parser/GPU upload still running → `decoding`; finished.
 * `failed` is rendered briefly so the user knows why nothing appeared.
 */
export type SplatLoadingPhase = 'fetching' | 'decoding' | 'failed';

export interface SplatLoadingEntry {
  layerId: string;
  layerName: string;
  phase: SplatLoadingPhase;
  /** 0..1 transfer progress; only meaningful while `phase === 'fetching'`
   *  and the response carried a `Content-Length` header. */
  progress?: number;
  /** Bytes pulled from the wire so far — used as a fallback label when
   *  total length is unknown. */
  loadedBytes?: number;
  /** Total bytes if `Content-Length` was present. */
  totalBytes?: number;
  /** Error message for the `failed` phase. */
  error?: string;
}

export const splatLoadingAtom = atom<Record<string, SplatLoadingEntry>>({});
